import api from './index'

export default {
	sendFeedback (data, payload) {
		return api.fetch(api.getStore().getters.apiGetUrl + '/feedback/send', {
			method: 'POST',
			postparams: data
		}, payload)
	}
}



// WEBPACK FOOTER //
// ./src/api/feedback.js